/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    ol: "ol",
    li: "li",
    h3: "h3",
    pre: "pre",
    code: "code",
    h4: "h4"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Webhook"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.niagahoster.co.id/blog/webhook-adalah/",
        children: "niagahoster"
      }), " の記事によると、Webhookはシステム間の通信の方法で、特にコールバック（呼び戻し）を行う仕組みです。簡単に言うと、Webhook機能によってMAXは他のシステムやアプリケーションと連携できます。"]
    }), "\n", _jsx(_components.p, {
      children: "現在、MAXにはネイティブに統合されたWebhookが2種類あります。："
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Discord Webhook"
      }), "\n", _jsx(_components.li, {
        children: "HTTP Webhook"
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Discord Webhook"
    }), "\n", _jsx(_components.p, {
      children: "この機能を有効にすると、MAXが指定したDiscordチャンネルに受信したサポートを「記録」します。"
    }), "\n", _jsx(_components.h3, {
      children: "HTTP Webhook (Advance)"
    }), "\n", _jsx(_components.p, {
      children: "独自にカスタム連携を作成したい場合、HTTP Webhookも利用できます！"
    }), "\n", _jsx(_components.p, {
      children: "MAXからあなたのシステムへのWebhookリクエスト："
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "Method: POST\nContent-Type: application/json\nHeader: {\n    Saweria-Callback-Signature: string\n}\n\nBody: {\n    version: string\n    created_at: string\n    id: string\n    amount_raw: integer\n    cut: integer\n    donator_name: string\n    donator_email: string\n    donator_is_user: bool\n    message: string\n}\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "Signature"
    }), "\n", _jsxs(_components.p, {
      children: ["ヘッダーには ", _jsx(_components.code, {
        children: "Saweria-Callback-Signature"
      }), " が含まれており、この値でコールバックがMAXから送信されたことを確認できます。"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "Saweria-Callback-Signature"
      }), " を検証するコード例"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-python",
        children: "# Python code\nimport hmac\n\nsaweria_streaming_key = \"xxxx\"\n\n# from callback, order sensitive!\ncallback_payload = [version, id, amount_raw, donator_name, donator_email]\n\nmsg = \"\".join([v for v in callback_payload]).encode()\n\nsignature = hmac.new(key=saweria_streaming_key.encode(), msg=msg, digestmod=sha256).hexdigest()\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
